"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useFocus = require("../../utils/hooks/useFocus");
var _waffle = _interopRequireDefault(require("../../images/waffle.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileDashboardMenu = _ref => {
  let {
    links,
    cta,
    text,
    toggleDropDown,
    isOpen,
    closeDropDown,
    Link,
    currentOpenMenu,
    hamburgerIsOpen
  } = _ref;
  const {
    mouse
  } = _useMouse.default;
  const [collapsedMenu, setCollapsedMenu] = (0, _useFocus.useFocus)();
  const [uncollapsedMenu, setUncollapsedMenu] = (0, _useFocus.useFocus)();
  const generateMenuLinks = () => {
    return links.map((_ref2, i) => {
      let {
        title,
        description,
        linkText,
        externalUrl
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: "luna-waffle-menu__drop-down__menu-item"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "luna-waffle-menu__drop-down__menu-item__product-name"
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: "luna-waffle-menu__drop-down__menu-item__description"
      }, description), /*#__PURE__*/_react.default.createElement("div", {
        className: "luna-waffle-menu__drop-down__menu-item__cta"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: externalUrl,
        className: "luna-waffle-menu__drop-down__menu-item__cta__link",
        target: "_blank"
      }, linkText)));
    });
  };
  const toggleWithEnter = (e, name, direction) => {
    if (e.keyCode === 13) {
      toggleDropDown(name);
      if (direction === "open") {
        setCollapsedMenu();
      } else {
        setUncollapsedMenu();
      }
    }
  };
  const invisible = currentOpenMenu !== null;
  if (Array.isArray(links) && links.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
      className: `ter-mobile-mega-menu ${isOpen ? "ter-mobile-mega-menu--reveal" : "ter-mobile-mega-menu--reveal--from-right"}`
    }, /*#__PURE__*/_react.default.createElement("p", {
      // id={formatID(`${text}-mini-menu-name`)}
      className: `ter-mobile-mega-menu__name ${isOpen ? "ter-mobile-mega-menu__name--open" : ""} ${mouse ? "" : "tabFocus"}`,
      tabIndex: mouse ? "" : "0",
      onClick: () => toggleDropDown(text),
      onKeyDown: e => toggleWithEnter(e, text, "open"),
      "aria-haspopup": "menu",
      "aria-expanded": isOpen,
      ref: uncollapsedMenu,
      "data-depth": 1
    }, text, /*#__PURE__*/_react.default.createElement("img", {
      className: `ter-mobile-menu__caret ${isOpen ? "ter-mobile-menu__caret--up" : "ter-mobile-menu__caret--down"}`,
      src: _rightCaretLightGray.default,
      alt: "caret icon"
    })), /*#__PURE__*/_react.default.createElement("ul", {
      className: `ter-mobile-menu__link-container ter-mobile-menu__link-container--is-open`
    }, generateMenuLinks()), cta?.reference && /*#__PURE__*/_react.default.createElement("footer", {
      className: "luna-waffle-menu__drop-down__footer"
    }, /*#__PURE__*/_react.default.createElement(Link, {
      to: cta.reference.slug,
      className: "luna-waffle-menu__drop-down__footer__link"
    }, cta.title))), /*#__PURE__*/_react.default.createElement("section", {
      className: `ter-mobile-mega-menu ${invisible ? "ter-mobile-mega-menu--inactive" : ""}`
    }, /*#__PURE__*/_react.default.createElement("p", {
      // id={formatID(`${text}-mini-menu-name`)}
      className: `ter-mobile-mega-menu__name ter-mobile-mega-menu__name__flex ter-mobile-mega-menu__name__utility-link ter-mobile-mega-menu__name__utility-link__last ${currentOpenMenu || !hamburgerIsOpen ? "" : "ter-mobile-mega-menu__name--open-parent"} ${mouse ? "" : "tabFocus"}`,
      onClick: () => toggleDropDown(text),
      onKeyDown: e => toggleWithEnter(e, text, "close"),
      tabIndex: mouse ? "" : "0",
      "aria-haspopup": "menu",
      "aria-expanded": !isOpen,
      ref: collapsedMenu,
      "data-depth": 1
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _waffle.default,
      className: "ter-mobile-mega-menu__name__flex__icon",
      width: "16",
      height: "16",
      alt: ""
    }), text, /*#__PURE__*/_react.default.createElement("img", {
      className: `ter-mobile-menu__caret ${isOpen ? "ter-mobile-menu__caret--up" : "ter-mobile-menu__caret--down"}`,
      src: _downCaretDarkBlue.default,
      alt: "caret icon"
    }))));
  }
  return null;
};
var _default = MobileDashboardMenu;
exports.default = _default;